import {
  Box,
  Checkbox,
  LinkButton,
  // CheckboxGroup,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Text,
} from '@tonic-one/react';
import { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { ServiceNameEnum } from '@Types/index';

import { useLicenseStore } from '../../../models/useLicenseModel';
import { SERVICE_NAME_ORDER_MAP, SERVICE_TYPES } from '../../../utils/service';
import { useGlobalSettingStore } from '../../../models/useGlobalSettingModel';

const ServiceCheckbox = (props: {
  checkedServices: ServiceNameEnum[];
  setCheckedServices: any;
}) => {
  const { selectedOrgGlobalSetting } = useGlobalSettingStore();
  const excludeServices: Set<ServiceNameEnum> = new Set<ServiceNameEnum>([
    ServiceNameEnum.MicrosoftIdentityProtection,
    ServiceNameEnum.MicrosoftInformationProtection,
  ]);
  if (!selectedOrgGlobalSetting.smexHybridFeatureShow) {
    excludeServices.add(ServiceNameEnum.ExchangeServer);
  } else if (!selectedOrgGlobalSetting.gmailInlineFeatureShow) {
    excludeServices.add(ServiceNameEnum.GmailInline);
  }
  const licenseModule = useLicenseStore();
  if (
    !licenseModule.license['CAS-SF'] ||
    licenseModule.license['CAS-SF'].enabled === false
  ) {
    excludeServices.add(ServiceNameEnum.SalesforceSandbox);
    excludeServices.add(ServiceNameEnum.SalesforceProduction);
  }
  if (!selectedOrgGlobalSetting.exchangeInlineFeatureShow) {
    excludeServices.add(ServiceNameEnum.ExchangeInline);
  }
  const services = SERVICE_TYPES.filter(
    (x) => !excludeServices.has(x.name)
  ).sort((a, b) => a.order - b.order);
  const { t } = useTranslation();

  const isAllSelected = props.checkedServices.length === services.length;

  function handleCheck(e: any) {
    const value = e.target.value as ServiceNameEnum;
    const items = [...props.checkedServices];
    if (e.target.checked) {
      items.push(value);
    } else {
      items.splice(items.indexOf(value), 1);
    }
    items.sort((s1, s2) => {
      return SERVICE_NAME_ORDER_MAP[s1] - SERVICE_NAME_ORDER_MAP[s2];
    });
    props.setCheckedServices(items);
  }

  const handleClickToggle = () => {
    const nextValue = isAllSelected
      ? []
      : services.map((service) => service.name);
    props.setCheckedServices(nextValue);
  };

  function renderMenuList() {
    return (
      <MenuList width="max-content">
        <Box px="3x" mb="2x">
          <LinkButton key="toggle" onClick={handleClickToggle}>
            {isAllSelected
              ? t('common.service.clearAll')
              : t('common.service.selectAll')}
          </LinkButton>
        </Box>
        {services.map((service) => {
          return (
            <MenuItem key={service.name} lineHeight="20px">
              <Checkbox
                value={service.name}
                checked={props.checkedServices.indexOf(service.name) > -1}
                onClick={(e: any) => handleCheck(e)}
              >
                {t(`common.service.${service.name}`)}
              </Checkbox>
            </MenuItem>
          );
        })}
      </MenuList>
    );
  }

  return (
    <Menu closeOnSelect={false}>
      <MenuButton variant="secondary" width="287px">
        <Text size="sm">
          {t('common.label.selectedServices')} ({props.checkedServices.length})
        </Text>
      </MenuButton>
      {renderMenuList()}
    </Menu>
  );
};

export default memo(ServiceCheckbox);
